<template>
  <div class="centered-icon-content flex-row align-center h-full">
    <div class="flex-col gap-10 justify-center align-center w-full">
      <div class="flex-col gap-6 justify-center w-full">
        <slot name="icon">
          <Component
            :is="icon"
            v-if="icon"
            :class="['centered-icon-content__icon', iconColorClass]"
            size="64"
          />
        </slot>

        <TitleBlock
          :title="title"
          :subtitle="subtitle"
          variant="large"
          align="center"
        />
      </div>

      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type Component, computed } from 'vue'

import TitleBlock from '@/components/typography/TitleBlock.vue'

const props = withDefaults(
  defineProps<{
    icon?: Component
    iconColor?: 'secondary' | 'success' | 'warning' | 'danger'
    title: string
    subtitle: string
  }>(),
  {
    icon: undefined,
    iconColor: 'secondary',
  }
)

const iconColorClass = computed(() => {
  switch (props.iconColor) {
    case 'success':
      return 'status-success'
    case 'secondary':
      return 'text-color-secondary'
    case 'warning':
      return 'status-warning'
    case 'danger':
      return 'status-danger'
    default:
      return 'text-color-secondary'
  }
})
</script>

<style lang="scss" scoped>
.centered-icon-content {
  &__icon {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
